var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListUneleced(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3335 1.44434H5.52832V2.83318H17.3335V1.44434Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3335 6.30469H5.52832V7.69354H17.3335V6.30469Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.3335 11.166H5.52832V12.5549H17.3335V11.166Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.05584 3.52768C2.82287 3.52768 3.44468 2.90588 3.44468 2.13884C3.44468 1.37181 2.82287 0.75 2.05584 0.75C1.2888 0.75 0.666992 1.37181 0.666992 2.13884C0.666992 2.90588 1.2888 3.52768 2.05584 3.52768Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.05584 8.38901C2.82287 8.38901 3.44468 7.7672 3.44468 7.00017C3.44468 6.23313 2.82287 5.61133 2.05584 5.61133C1.2888 5.61133 0.666992 6.23313 0.666992 7.00017C0.666992 7.7672 1.2888 8.38901 2.05584 8.38901Z",
    fill: "#82AFF8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.05584 13.2494C2.82287 13.2494 3.44468 12.6276 3.44468 11.8605C3.44468 11.0935 2.82287 10.4717 2.05584 10.4717C1.2888 10.4717 0.666992 11.0935 0.666992 11.8605C0.666992 12.6276 1.2888 13.2494 2.05584 13.2494Z",
    fill: "#82AFF8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListUneleced);
export default __webpack_public_path__ + "static/media/list_uneleced.1aad561b236c7ff41c5dfebd7282e8d0.svg";
export { ForwardRef as ReactComponent };